import { Theme } from "@mui/material";

export const TitleSizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes["3xl"],
        },
        md: {
            fontSize: theme.fontSizes["4xl"],
        }
    };
};


export const SubTitleSizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes.sm,
        },
        md: {
            fontSize: theme.fontSizes.md,
        }
    };
};